import { observer } from "mobx-react";
import React from "react";
import WorkflowInstanceList from "./WFRInstanceList";
import { Box } from "@mui/material";

import {
    ModulesLoading,
    WorkflowReviewStore,
} from "../Stores/WorkflowReviewStore";
import { useStore } from "utils/useStore";
import theme from "Theme/AppTheme";

interface WFRCapaModuleCardProps {
    navigateBack: () => void;
}

const WFRCapaModuleCard: React.FC<WFRCapaModuleCardProps> = observer(() => {
    const store = useStore(WorkflowReviewStore);

    return (
        !store.getTaskLoadingV2(ModulesLoading) && (
            <Box sx={{ margin: theme.spacing(2, 8, 2, 8) }}>
                <WorkflowInstanceList />
            </Box>
        )
    );
});
export default WFRCapaModuleCard;
